import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { AttachmentResponse } from '@/api/services/common/attachment/common-attachment.dto'

class ConfigurationSynopticTemplateExternalDocumentationService {
    async get(laboratoryId: number, synopticTemplateId: number): Promise<AxiosResponse<Blob>> {
        const config: AxiosRequestConfig = {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }
        return axios.get<Blob>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/${synopticTemplateId}/externalDocumentation`, config)
    }

    async update(laboratoryId: number, synopticTemplateId: number, file: File, thumbnail?: File, notes?: string): Promise<AttachmentResponse> {
        const formData = new FormData()
        formData.append('file', file, file.name)
        if (thumbnail) {
            formData.append('thumbnail', thumbnail, thumbnail.name)
        }

        const config: AxiosRequestConfig = {
            headers: { 'content-type': 'multipart/form-data' },
            params: { notes }
        }

        const response = await axios.put<AttachmentResponse>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/${synopticTemplateId}/externalDocumentation`, formData, config)
        return response.data
    }

    async delete(laboratoryId: number, synopticTemplateId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/${synopticTemplateId}/externalDocumentation`)
        return response.data
    }
}
export const configurationSynopticTemplateExternalDocumentationService = new ConfigurationSynopticTemplateExternalDocumentationService()
